__turbopack_context__.v({
  "saveIcon": "styles-module__vgg9-q__saveIcon",
});
